module.exports = __webpack_public_path__ + "iconfont.ttf?305639e808c28dcf45d0b98715d16247";


//////////////////
// WEBPACK FOOTER
// ./src/css/icon-font/iconfont.ttf?t=1524543712941
// module id = 10
// module chunks = 0